"use strict";



function getCurrentHeading (headings) {

    const headingsAbove = [...headings].filter(heading => {
        return getPositionTop(heading) <= window.scrollY + 51
    })

    if ( headingsAbove.length > 0 ) {
        return headingsAbove[headingsAbove.length - 1];
    }

    return null;
}


function getPositionTop (elem) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return elem.getBoundingClientRect().top + scrollTop;
}


export default function ({sidebar, headings, stoppers}) {
    if ( !sidebar || !headings || !stoppers ) return false;

    const sidebarElem = document.querySelector(sidebar);
    const headingElems = document.querySelectorAll(headings);
    const stopElements = document.querySelectorAll(stoppers);


    if ( !sidebarElem || !headingElems || !stopElements ) return false;

    const menuElem = sidebarElem.querySelector('ol');


    let sidebarAbsoluteTop = null;


    function addSticky (sidebar) {
        sidebarElem.classList.add('sticky');
        sidebarElem.style.top = '';
        sidebarElem === null;
    }


    function setupSidebar () {

      headingElems
        .forEach(heading => {
          const menuItem = document.createElement('li');
          const menuLink = document.createElement('a');

          menuLink.href = `#${heading.id}`;
          menuLink.innerHTML = heading.innerHTML;

          menuItem.append(menuLink);
          menuElem.append(menuItem);
        });

      const sideNavItems = sidebarElem.querySelectorAll('a');

        const sidebarStartPositionTop = getPositionTop(sidebarElem);

        function activate () {
            // Link highlight
            const currentHeading = getCurrentHeading(headingElems);

            if ( currentHeading ) {
                sideNavItems.forEach(link => {
                    if ( currentHeading.id === link.href.split('#')[1] ) {
                        link.parentElement.classList.add('active');
                    } else {
                        link.parentElement.classList.remove('active');
                    }
                });
            }


            // Sticky sidebar
            const currentSidebarPosition = window.scrollY + sidebarElem.getBoundingClientRect().height;
            const currentStopPosition = [...stopElements]
                                            .map(getPositionTop)
                                            .reduce((total,position) => (position < total) ? position : total, Infinity);

            const sidebarOffset = currentStopPosition - sidebarStartPositionTop - sidebarElem.getBoundingClientRect().height;
            const stopAtBottom = currentSidebarPosition > currentStopPosition;

            if ( window.scrollY <= sidebarStartPositionTop || stopAtBottom ) {
                sidebarElem.classList.remove('sticky');

                if ( stopAtBottom ) {
                    if ( sidebarAbsoluteTop === null ) {
                        sidebarAbsoluteTop = sidebarOffset;
                    }
                    sidebarElem.style.top = sidebarAbsoluteTop + 'px';
                }
            }
            else if ( sidebarElem.getBoundingClientRect().top < 0 || !stopAtBottom ) {
                addSticky(sidebarElem);
            }
        }

        window.addEventListener('scroll', activate);
        window.addEventListener('resize', activate);
        activate();
    }

    window.addEventListener('load', setupSidebar);
}
